import { render, staticRenderFns } from "./AppDeleteConfirmation.vue?vue&type=template&id=79b4fcf5&"
import script from "./AppDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./AppDeleteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports